import { Form, Title } from 'ui';
import { Separator, SocialButtons } from '../../../components';
import type { PrimaryOrganizationOption } from '../primary-organization-select';
import { SignUpForm, type SignUpFormValues } from './sign-up-form';

type P = {
  changeRequestId?: string;
  initialOrganization?: PrimaryOrganizationOption;
  invitationToken?: string;
  loading: boolean;
  onNavigateToCheckCode: ({ tokenToGetCode, tokenToLogin }: { tokenToGetCode?: string; tokenToLogin?: string }) => void;
  onSubmit: (values: SignUpFormValues) => void;
  onSuccessLogin: () => Promise<void>;
};

const SignUpUser = ({
  changeRequestId,
  initialOrganization,
  invitationToken,
  loading,
  onNavigateToCheckCode,
  onSubmit,
  onSuccessLogin,
}: P) => {
  const [form] = Form.useForm<SignUpFormValues>();

  const hasAnySocialLogin = Boolean(import.meta.env.VITE_APP_GOOGLE_CLIENT_ID);

  return (
    <>
      <Title level={1} marginBottom>
        Sign up
      </Title>
      <SignUpForm
        changeRequestId={changeRequestId}
        form={form}
        initialOrganization={initialOrganization}
        invitationToken={invitationToken}
        loading={loading}
        onSubmit={onSubmit}
      />
      {hasAnySocialLogin ? (
        <>
          <Separator text="or" />
          <SocialButtons
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
            getOrganizationId={() => form.getFieldsValue()?.organization?.value}
            onNavigateToCheckCode={onNavigateToCheckCode}
            onSuccessLogin={onSuccessLogin}
          />
        </>
      ) : null}
    </>
  );
};

export default SignUpUser;
